import { render, staticRenderFns } from "./ModalSandbox.vue?vue&type=template&id=1b6e1ef7&scoped=true&"
import script from "./ModalSandbox.vue?vue&type=script&lang=js&"
export * from "./ModalSandbox.vue?vue&type=script&lang=js&"
import style0 from "./ModalSandbox.vue?vue&type=style&index=0&id=1b6e1ef7&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6e1ef7",
  null
  
)

export default component.exports